<template>
  <model-provider :service="service" :model-id="id">
    <template #default="{model}">
      <b-card class="flex flex-col gap-4">
        <contact-form ref="form" @reset="$router.back()" @submit="storeContact" :model="model">
          <template #reset-button-text>
            Voltar
          </template>
        </contact-form>
      </b-card>
    </template>
  </model-provider>
</template>

<script>
import ContactService from '@/services/api/ContactService'
import ModelProvider from '@/components/ModelProvider.vue'

import {
  BCard,
  BButton,
  BTable
} from 'bootstrap-vue'
import ContactForm from './ContactForm.vue'

export default {

  props: {
    id: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    service: null,
    model: {
      name: '',
      email: '',
      phone: ''
    }
  }),

  components: {
    BCard,
    BButton,
    ContactForm,
    BTable,
    ModelProvider
  },

  beforeMount() {
    this.service = ContactService.build(this.$vs)
  },

  methods: {
    storeContact(data) {
      this.clearErrors(this.$validator)
      this.$vs.loading()
      this.service.createOrUpdate({
        id: this.id,
        ...data
      }).then(
        response => {
          this.notifySuccess(this.$vs, "Operação realizada com sucesso!")
          this.model = response
          this.$router.push(`/contacts/${response.id}/edit`)
        },
        error => {
          this.$refs.form.showValidationErrors(error)
          this.notifyError(this.$vs, "Não foi possível realizar esta operação.")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    }
  }
}
</script>

<style>

</style>